/**
 * CoinsPolicyPage
 *
 * Static public page displaying the Coins Policy.
 * Accessible without authentication.
 */
import { useLocale } from '@/presentation/contexts/LocaleContext';
import { LegalDocumentPage } from './LegalDocumentPage';
import coinsPolicyHtml from './content/coinsPolicy.html?raw';

export const CoinsPolicyPage = () => {
  const { l10n } = useLocale();
  return (
    <LegalDocumentPage
      qaId="legal-coins-policy"
      title={l10n.legal.coinsPolicy}
      htmlContent={coinsPolicyHtml}
    />
  );
};
